import { Permission } from "../types/permission.types";

export const hasPermission = (
  menuPath: string,
  userPermissions: Permission[]
): boolean => {
  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false;
  }
  return userPermissions.some(
    (p) => p.menuPath === menuPath && p.canView === true
  );
};

export const hasAllPermissions = (
  menuPaths: string[],
  userPermissions: Permission[]
): boolean => {
  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false;
  }
  return menuPaths.every((path) => hasPermission(path, userPermissions));
};

export const hasAnyPermissions = (
  menuPaths: string[],
  userPermissions: Permission[]
): boolean => {
  if (!userPermissions || !Array.isArray(userPermissions)) {
    return false;
  }
  return menuPaths.some((path) => hasPermission(path, userPermissions));
};
